import React from 'react'
import SearchOutlined from '@ant-design/icons/SearchOutlined'

const SuggestionItem = ({title, searchValue, onClick}) => (
  <button className='searchMainSuggestions' onClick={onClick}>
    <span className='searchMainSuggestions-text'>
      {title.indexOf(searchValue) > -1 ? (
        <>{title.split(searchValue)[0]}<b>{searchValue}</b>{title.split(searchValue)[1]}</>
      ) : (
        title
      )}
    </span> <SearchOutlined/>
  </button>
)

const Suggestions = ({t, suggestions, handleSearch = () => {}, searchValue}) => (
  <div className='productsList-suggestions'>
    <h4>{t('Suggestions for')} <b>"{searchValue}"</b></h4>
    <div>
      <div>
        {suggestions?.map(e => (
          <SuggestionItem
            key={e.hl}
            onClick={() => handleSearch({target: {value: e.hl}})}
            title={e.hl}
            searchValue={searchValue}
          />
        ))}
      </div>
    </div>
  </div>
)

export default Suggestions
